import { atom } from 'jotai';

import {
  scalesQueryAtom,
  type Scale,
} from '~/shared/graphql/queries/useScalesQuery';
import { $facilityId } from '~/shared/providers/auth/identity.localState';

export const $globalScalesQuery = scalesQueryAtom((get) => {
  const facilityId = get($facilityId);
  return {
    variables: {
      facilityId: facilityId ?? undefined,
    },
  };
});

export const $globalScales = atom<Scale[]>((get) => {
  const queryResult = get($globalScalesQuery);
  return queryResult.data?.scales ?? [];
});

export const $globalScalesLoading = atom((get) => {
  const queryResult = get($globalScalesQuery);
  return queryResult.isLoading;
});

export const $globalScalesError = atom((get) => {
  const queryResult = get($globalScalesQuery);
  return queryResult.error;
});
